import { useMutation, useQuery } from '@apollo/client'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import LayoutTable from '../../../Global/LayoutTable'
import ContentHeader from '../../../Layout/ContentHeader'
import { AuthContext } from '../../../../Auth/AuthContext'
import usePermissions from '../../../../CustomHooks/usePermissions'
import { useLoading } from '../../../../LoadingOverlay/LoadingOverlayContext'
import ModalContentAux from '../../../Global/ModalContentAux'
import ProgressBarStatus from '../../../Global/ProgressBarStatus'
import { objNameRoles } from '../../../../const/constRoles'
import { fnObjNameStatus } from '../../../../const/constStatuses_waterTruckRequest'
import ModalStatus from './components/ModalChangeStatus/ModalStatus'
import ModalFilters from './components/ModalFilters'
import {
  CHANGE_STATUS_TO_EXTEMPORANEOUS_WATER_TRUCK,
  CHANGE_STATUS_WATER_TRUCK,
  CHANGE_WATER_TRUCK_STATUS,
  DELETE_WATER_TRUCK,
  GET_ALL_WATER_TRUCKS,
} from '../../../../graphql/Catalog/WaterTruckRequest/waterTruckRequest'
import PriorityBox from './components/PriorityBox'
import { GET_ALL_STATUS } from '../../../../graphql/Catalog/Status/status'
import {
  priorityOptions,
  typeDeliveryOptions,
} from './WaterTruckRequestNewAndEdit'
import { GET_ALL_PROVIDERS } from '../../../../graphql/Catalog/Providers/providers'
import { GET_ALL_COLONIES } from '../../../../graphql/Global/sepomex'
import { GET_CAPACITY_TRUCKS } from '../../../../graphql/Catalog/Trucks/trucks'

const allStatus = fnObjNameStatus()
const idModalFilters = 'modalFilters'
const linkRef = '/water-truck'
export const categorModule = 'water_truck_request'
export const categorStatusModule = 'water_truck_request_status'
/* console.log({
  allStatus,
}) */
const statusesAllowToCancel = [
  allStatus.nuevo, //id
  allStatus['En espera'],
]

const isStatusAllowwToCancel = (status, pipeGestor) => {
  console.log('pipeGestor', pipeGestor, 'status', status)
  if (pipeGestor) return true
  const isAllow = statusesAllowToCancel.includes(status)
  console.log('status', status, 'isAllow', isAllow)
  return isAllow
}

const WaterTruckRequest = () => {
  const { user } = useContext(AuthContext)
  const { showLoading, hideLoading } = useLoading()
  const history = useHistory()
  const MySwal = withReactContent(Swal)

  const isRoleProvider =
    user.role === objNameRoles.provedor_pipas ? true : false
  const isPipeGestor = objNameRoles.gestor_pipas === user.role

  const nameColumnDateType = [
    {
      value: 'planning_date',
      label: 'Fecha de planificación',
    },
    {
      value: 'completed_at',
      label: 'Fecha de completado',
    },
    {
      value: 'createdAt',
      label: 'Fecha de creación',
    },
  ]
  //PERMISSIONS
  const {
    create: permissionCreate,
    read: permissionRead,
    edit: permissionEdit,
    erase: permissionErase,
  } = usePermissions(user)

  //REFS
  const refModalFilters = useRef()
  const refModalStatus = useRef(null)

  //STATES
  const [options, setOptions] = useState({
    status: [],
    provider: [],
  })
  const [dataTable, setDataTable] = useState([])
  const [count, setCount] = useState(0)
  const [isFiltered, setIsFiltered] = useState(false)
  const [pagePagination, setPagePagination] = useState({
    searchQuery: null,
    limit: 10,
    offset: 0,
    filters: {
      status_id: null,
      nameColumnDateType: 'createdAt',
      dateFrom: null,
      dateTo: null,
      volume: null,
      priority: null,
      type_delivery: null,
      provider_id: null,
      order: [{ column: 'id', type: 'DESC' }],
      colony_id: null,
    },
  })
  const [closeModal, setCloseModal] = useState(false)
  const [modal, setModal] = useState({
    modalId: false,
    size: 'extra',
    title: '',
    content: null,
  })
  const [coloniesOptions, setColoniesOptions] = useState([])
  const [capacityOptions, setCapacityOptions] = useState([])

  //QUERIES
  const { loading, error, data, refetch } = useQuery(GET_ALL_WATER_TRUCKS, {
    variables: {
      limit: pagePagination.limit,
      offset: pagePagination.offset,
      searchQuery: pagePagination.searchQuery,
      filters: pagePagination.filters,
    },
    fetchPolicy: 'cache-and-network', //no-cache
  })

  const {
    loading: loadingStatus,
    error: errorStatus,
    data: dataStatus,
  } = useQuery(GET_ALL_STATUS, {
    variables: {
      type: categorModule,
    },
    skip: loading,
  })

  const {
    loading: loadingProviders,
    error: errorProviders,
    data: dataProviders,
  } = useQuery(GET_ALL_PROVIDERS, {
    variables: {},
    skip: isRoleProvider,
  })

  const {
    data: dataColonies,
    loading: loadingColonies,
    error: errorColonies,
  } = useQuery(GET_ALL_COLONIES, {
    fetchPolicy: 'cache-first',
  })
  const {
    data: dataCapacity,
    loading: loadingCapacity,
    error: errorCapacity,
  } = useQuery(GET_CAPACITY_TRUCKS, {
    fetchPolicy: 'cache-and-network',
  })

  //MUTATIONS
  const [deleteWater] = useMutation(DELETE_WATER_TRUCK)
  const [changeToExtemporaneous] = useMutation(
    CHANGE_STATUS_TO_EXTEMPORANEOUS_WATER_TRUCK
  )
  const [changeStatus] = useMutation(CHANGE_WATER_TRUCK_STATUS)

  useEffect(() => {
    try {
      if (loading) return
      if (loadingStatus) return
      if (errorStatus) throw errorStatus

      if (!dataStatus) return

      const { getAllCatalogStatus } = dataStatus

      if (getAllCatalogStatus.count === 0) return

      const status = getAllCatalogStatus.rows.map((item) => {
        return {
          value: item.id,
          label: item.name,
        }
      })

      setOptions((prev) => ({
        ...prev,
        status: status,
      }))
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [dataStatus, errorStatus, loadingStatus, loading])

  useEffect(() => {
    if (isRoleProvider) return
    try {
      if (loadingProviders) return
      if (errorProviders) throw errorProviders
      let list = []
      dataProviders.getAllProviders.rows.map((provider) => {
        return list.push({
          value: provider.id,
          label: `${provider.card_name} - ${provider.rfc}`,
        })
      })

      setOptions((prev) => ({
        ...prev,
        provider: list,
      }))
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [dataProviders, errorProviders, loadingProviders])

  //FUNCTIONS
  const handleOpenModal = (e, item) => {
    e.preventDefault()
    setModal({
      id: item.id,
      modalId: `modal${item.id}`,
      size: 'extra',
      title: `Solicitud pipa ${item.folio}`,
      content: (
        <ModalStatus
          id={parseInt(item.id)}
          dataMain={item}
          refetchMain={refetch}
          setCloseModal={setCloseModal}
        />
      ),
    })
  }

  const handleBtnAccions = async ({ type, item = null }) => {
    if (type === 'add') {
      return history.push(`${linkRef}/new`)
    } else if (type === 'show') {
      return history.push(`${linkRef}/details/${item.id}/show`)
    } else if (type === 'edit') {
      return history.push(`${linkRef}/edit/${item.id}`)
    } else if (type === 'delete') {
      return handleDelete(parseInt(item.id))
    } else if (type === 'extemporaneus') {
      return handleChangeToExtemporaneous(parseInt(item.id))
    }
  }

  const handleDelete = async (id) => {
    MySwal.fire({
      showCloseButton: true,
      icon: 'warning',
      title: '¿Estas seguro de eliminar el registro?',
      html: <div className="message-container">Esta accion es permanente</div>,
      allowOutsideClick: false,
      buttonsStyling: false,
      showDenyButton: true,
      confirmButtonText: 'Aceptar',
      denyButtonText: 'Cancelar',
      reverseButtons: true,
      customClass: {
        title: 'StandarModalTitle',
        htmlContainer: 'StandarModalHtmlContainer',
        confirmButton: 'btn btn-migrates',
        denyButton: 'btn btn-migrates-white',
        footer: 'btn StandarModalFooterLogOut',
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        showLoading()
        try {
          await deleteWater({ variables: { id } })
          await refetch()
          return toastSweetAlert({
            mode: 'ok',
            message: 'Registro ha sido eliminado',
          })
        } catch (error) {
          toastSweetAlert({
            mode: 'error',
            message: error.message,
          })
        } finally {
          hideLoading()
        }
      }
    })
  }

  const handleBtnCancel = async (item) => {
    MySwal.fire({
      showCloseButton: true,
      icon: 'warning',
      title: '¿Estas seguro de Cancelar el registro?',
      html: <div className="message-container">Esta accion es permanente</div>,
      allowOutsideClick: false,
      buttonsStyling: false,
      showDenyButton: true,
      confirmButtonText: 'Aceptar',
      denyButtonText: 'Cancelar',
      reverseButtons: true,
      customClass: {
        title: 'StandarModalTitle',
        htmlContainer: 'StandarModalHtmlContainer',
        confirmButton: 'btn btn-accept-green',
        denyButton: 'btn btn-migrates-white',
        footer: 'btn StandarModalFooterLogOut',
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        showLoading()

        try {
          await changeStatus({
            variables: {
              changeWaterTruckStatusId: item.id,
              statusId: allStatus.cancelado,
            },
          })
          await refetch()

          return toastSweetAlert({
            mode: 'ok',
            message: 'Registro ha sido cancelado',
          })
        } catch (error) {
          toastSweetAlert({
            mode: 'error',
            message: error.message,
          })
        } finally {
          hideLoading()
        }
      }
    })
  }

  //EFFECTS
  useEffect(() => {
    try {
      if (loading) return
      if (error) throw error

      const { getAllWaterTruckRequests } = data

      const isRoleProvider =
        user.role === objNameRoles.provedor_pipas ? true : false

      const list = getAllWaterTruckRequests.rows.map((item) => {
        const isNewOrPlanning = [
          allStatus.nuevo,
          allStatus.planificar_pipa,
          allStatus.extemporaneo,
        ].includes(item.status_id)
        const newStatus = allStatus.nuevo
        const cancelledStatus = allStatus.cancelado

        return {
          id: item.id,
          Folio: item.folio,
          Volumen: `${item.volume} m³`,
          Prioridad: (
            <PriorityBox
              priority={item.priority}
              normalStyle={{
                backgroundColor: '#DBE6FF',
                color: '#374151',
                border: '0px',
                padding: '8px 2px',
                borderRadius: '4px',
                width: '100%',
                marginRight: '100px',
              }}
              urgentStyle={{
                backgroundColor: '#DA1E28',
                color: '#FFFFFF',
                border: '0px',
                padding: '8px 2px',
                borderRadius: '4px',
                width: '100%',
                marginRight: '100px',
              }}
              showImage={false}
            />
          ),
          // Extemporaneo: item.is_extemporaneous ? 'Si' : 'No',
          Tipo: item.type_delivery,
          Provedor: item.ProviderOfWaterTruckRequest?.card_name,
          Colonia: item.ColonyOfWaterTruckRequest?.name || 'N/A',
          Dirección: item.AddressOfWaterTruckRequest?.address_full,
          Estatus: (
            <ProgressBarStatus
              category={categorModule}
              status={item.StatusOfWaterTruckRequest}
              staticProcess={true}
            />
          ),
          // Progreso: (
          //   <ProgressBarStatus
          //     category={categorModule}
          //     status={item.StatusOfWaterTruckRequest}
          //   />
          // ),
          accions_custom: (
            <div className="my-3 d-flex flex-column acciones">
              <div className="d-flex" style={{ gap: '5px' }}>
                {!isRoleProvider && isNewOrPlanning ? (
                  <>
                    {permissionRead && (
                      <button
                        type="button"
                        className="btn btn-migrates btn-migrates-cover btn-sm mb-1"
                        onClick={() => handleBtnAccions({ type: 'show', item })}
                        title="Ver"
                      >
                        <i className="fas fa-eye" />
                      </button>
                    )}
                    {permissionEdit && (
                      <button
                        type="button"
                        className="btn btn-migrates btn-migrates-cover btn-sm mb-1"
                        onClick={() => handleBtnAccions({ type: 'edit', item })}
                        title="Editar"
                      >
                        <i className="fas fa-edit" />
                      </button>
                    )}
                    {newStatus === item.status_id && (
                      <button
                        type="button"
                        className="btn btn-migrates btn-migrates-cover btn-sm mb-1"
                        onClick={() =>
                          handleBtnAccions({ type: 'extemporaneus', item })
                        }
                        title="Cambiar a extemporánea"
                      >
                        <i className="fas fa-stopwatch" />
                      </button>
                    )}
                    {/* {permissionErase && (
                      <button
                        type="button"
                        className="btn btn-danger btn-sm mb-1"
                        onClick={() =>
                          handleBtnAccions({ type: 'delete', item })
                        }
                        title="Eliminar"
                      >
                        <i className="fas fas fa-trash"></i>
                      </button>
                    )} */}
                  </>
                ) : (
                  <>
                    {permissionRead && (
                      <button
                        type="button"
                        className="btn btn-migrates btn-migrates-cover btn-sm mb-1"
                        onClick={() => handleBtnAccions({ type: 'show', item })}
                        title="Ver"
                      >
                        <i className="fas fa-eye" />
                      </button>
                    )}
                    {permissionEdit && isPipeGestor && (
                      <button
                        type="button"
                        className="btn btn-migrates btn-migrates-cover btn-sm mb-1"
                        onClick={() => handleBtnAccions({ type: 'edit', item })}
                        title="Editar"
                      >
                        <i className="fas fa-edit" />
                      </button>
                    )}
                  </>
                )}
                {!isRoleProvider &&
                  [allStatus.validacion].includes(item.status_id) && (
                    <button
                      type="button"
                      className="btn btn-migrates btn-migrates-cover btn-sm mb-1"
                      onClick={(e) => handleOpenModal(e, item)}
                      title="Procesar"
                    >
                      <i className="fas fa-gear" />
                    </button>
                  )}
                {isPipeGestor && cancelledStatus !== item.status_id && (
                  <button
                    type="button"
                    className="btn btn-migrates btn-migrates-cover btn-sm mb-1"
                    onClick={() => handleBtnCancel(item)}
                    title="Cancelar pipa"
                  >
                    <i className="fas fa-ban" />
                  </button>
                )}
              </div>
            </div>
          ),
        }
      })

      setDataTable(list)
      setCount(getAllWaterTruckRequests.count)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [data, error, loading])

  useEffect(() => {
    if (!loadingColonies && !errorColonies) {
      if (dataColonies) {
        const colonies = dataColonies.getAllColonies.map((item) => ({
          value: item.id,
          label: item.name,
          nocolonia: item.nocolonia,
        }))

        setColoniesOptions(colonies)
      }
    }
  }, [dataColonies, loadingColonies, errorColonies])

  useEffect(() => {
    if (modal) {
      document.getElementById(`spanModal${modal.modalId}`).click()
    }
  }, [modal])

  useEffect(() => {
    if (closeModal) {
      document.getElementById(`spanModal${modal.modalId}`).click()
      setCloseModal(false)
    }
  }, [closeModal])

  useEffect(() => {
    try {
      if (loadingCapacity) return
      if (errorCapacity) throw errorCapacity
      if (!dataCapacity)
        throw new Error('No se encontraron datos de las capacidades')

      const { getCapacityForTruck } = dataCapacity

      setCapacityOptions(getCapacityForTruck)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [loadingCapacity, errorCapacity, dataCapacity])

  useEffect(() => {
    const savedFilters = localStorage.getItem('filtersWaterTruck')
    const savedSearchQuery = localStorage.getItem(
      'filtersWaterTruckSearchQuery'
    )

    if (savedFilters) {
      setPagePagination((old) => ({
        ...old,
        searchQuery: savedSearchQuery ? JSON.parse(savedSearchQuery) : null,
        filters: JSON.parse(savedFilters),
      }))
      const nameColumnDateType = document.getElementById('filterThird')
      if (nameColumnDateType)
        nameColumnDateType.value =
          JSON.parse(savedFilters)?.nameColumnDateType || 'createdAt'
    }
  }, [])

  useEffect(() => {
    localStorage.setItem(
      'filtersWaterTruck',
      JSON.stringify(pagePagination.filters)
    )
  }, [pagePagination.filters])

  useEffect(() => {
    localStorage.setItem(
      'filtersWaterTruckSearchQuery',
      JSON.stringify(pagePagination.searchQuery)
    )
  }, [pagePagination.searchQuery])

  const handleFilterChange = (e, key) => {
    console.log(e, key)
    setPagePagination((prev) => ({
      ...prev,
      filters: {
        ...prev.filters,
        [key]: e ? e.value : null,
      },
    }))
  }

  const handleChangeToExtemporaneous = async (id) => {
    try {
      const response = await toastSweetAlert({
        mode: 'modalConfirmCancel',
        title: 'Cambiar a extemporáneo',
        message: '¿Estas seguro de cambiar el estatus a extemporáneo?',
        icon: 'warning',
        confirmButtonText: 'Aceptar',
      })

      if (!response.isConfirmed) return

      showLoading()
      const { data: dataChangeStatus } = await changeToExtemporaneous({
        variables: {
          id,
        },
      })

      if (dataChangeStatus.changeRequestToExtemporaneous) {
        await refetch()
        return toastSweetAlert({
          mode: 'ok',
          message: 'Cambio de estatus a extemporáneo realizado correctamente',
        })
      }
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
    }
  }

  const handleFiltersSelectMulti = (e, field) => {
    let arraySend = []
    if (e.length > 0) {
      arraySend = e.map((item) => item.value)
    }

    setPagePagination((old) => ({
      ...old,
      filters: {
        ...old.filters,
        [field]: arraySend,
      },
    }))
  }

  const handleClearFilters = () => {
    const defaultFilters = {
      status_id: null,
      nameColumnDateType: 'createdAt',
      dateFrom: null,
      dateTo: null,
      volume: null,
      priority: null,
      type_delivery: null,
      provider_id: null,
      order: [{ column: 'id', type: 'DESC' }],
      colony_id: null,
    }
    setPagePagination((old) => ({
      ...old,
      searchQuery: '',
      filters: defaultFilters,
    }))
    localStorage.removeItem('filtersWaterTruck')
    localStorage.removeItem('filtersWaterTruckSearchQuery')
    const searchBar = document.getElementById('searchBar')
    searchBar.value = ''

    const dateInputFrom = document.getElementById('dateInputFrom')
    if (dateInputFrom) dateInputFrom._flatpickr.setDate('', true)
    const dateInputTo = document.getElementById('dateInputTo')
    if (dateInputTo) dateInputTo._flatpickr.setDate('', true)
    const nameColumnDateType = document.getElementById('filterThird')
    if (nameColumnDateType) nameColumnDateType.value = 'createdAt'
  }

  return (
    <>
      <ContentHeader
        breadcrumb=""
        title="Pipas de Agua"
        windowTitle="Pipas de Agua"
        addNewButton={permissionCreate ? true : false}
        addNewButtonText="Agregar nuevo"
        addNewButtonOnClick={() => handleBtnAccions({ type: 'add' })}
        addNewButtonNoPermission
      />
      <LayoutTable
        hideId
        hideActions
        hideAddNew
        exportImportButton={false}
        title="Lista de pipas"
        data={dataTable}
        totalCount={count}
        loadingData={loading}
        pagePagination={pagePagination}
        setPagePagination={setPagePagination}
        gql={DELETE_WATER_TRUCK}
        refetchFunctionQueries={refetch}
        requery={null}
        FilterBarPlaceholder="Buscar por folio"
        filterBarValue={pagePagination.searchQuery}
        headerComponents={
          <>
            <button
              className="btn btn-purple btn-sm"
              title="Limpiar filtros"
              onClick={handleClearFilters}
            >
              <i className="fas fa-times" /> Limpiar filtros
            </button>
          </>
        }
        filterChoosen={[
          {
            id: 'status',
            name: 'Estatus',
            placeholder: 'Estatus',
            options: options.status,
            isClearable: true,
            isSearchable: true,
            onChange: (e) => handleFilterChange(e, 'status_id'),
            value: pagePagination.filters.status_id,
          },
          {
            id: 'volume',
            name: 'Volumen',
            placeholder: 'Volumen',
            options: capacityOptions,
            isClearable: true,
            isSearchable: true,
            onChange: (e) => handleFilterChange(e, 'volume'),
            value: pagePagination.filters.volume,
          },
          {
            id: 'priority',
            name: 'Prioridad',
            placeholder: 'Prioridad',
            options: priorityOptions,
            isClearable: true,
            isSearchable: true,
            onChange: (e) => handleFilterChange(e, 'priority'),
            value: pagePagination.filters.priority,
          },
          {
            id: 'type_delivery',
            name: 'Tipo de entrega',
            placeholder: 'Tipo de entrega',
            options: typeDeliveryOptions,
            isClearable: true,
            isSearchable: true,
            onChange: (e) => handleFilterChange(e, 'type_delivery'),
            value: pagePagination.filters.type_delivery,
          },
          {
            condition: isRoleProvider,
            id: 'provider',
            name: 'Proveedor',
            placeholder: 'Proveedor',
            options: options.provider,
            isClearable: true,
            isSearchable: true,
            onChange: (e) => handleFilterChange(e, 'provider_id'),
            noOptionsMessage: () => 'No hay proveedores',
            value: pagePagination.filters.provider_id,
          },
        ]}
        cols_search="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4"
        cols_search_div="col-12"
        cols_filters="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 mt-3"
        cols_filters_div="col-12"
        isFilterRangeShow
        filterRangeProps={{
          from: {
            value: pagePagination.filters.dateFrom,
            id: 'dateInputFrom',
          },
          to: {
            value: pagePagination.filters.dateTo,
            id: 'dateInputTo',
          },
          changeFilterDateRange: (e, label) => {
            const value = e.target.value
            if (label === 'from')
              return handleFilterChange({ value: value }, 'dateFrom')
            if (label === 'to')
              return handleFilterChange({ value: value }, 'dateTo')
          },
        }}
        // filterThird
        // filterOnChangeThird={(e) => {
        //   const value = e.target.value
        //   handleFilterChange({ value }, 'nameColumnDateType')
        // }}
        // filterOptionsThird={nameColumnDateType.map((item) => (
        //   <option value={item.value} key={item.value}>
        //     {item.label}
        //   </option>
        // ))}
        // defaultValueSelectThird={pagePagination?.filters?.nameColumnDateType || "createdAt"}
        filterFourth
        filterOnChangeFourth={(e) => handleFiltersSelectMulti(e, 'colony_id')}
        filterOptionsFourth={coloniesOptions}
        filterDefaultOptionTextFourth="Elige colonia(s)"
        filterTypeSelectFourth="selectMultiple"
        defaultValueSelectFourth={pagePagination.filters.colony_id
          ?.map((colony_id) => {
            const match = coloniesOptions?.find(
              (colony) => colony.value === colony_id
            )
            return match ? { label: match.label, value: match.value } : null
          })
          .filter(Boolean)}
      />

      <span
        ref={refModalFilters}
        className="btn btn-migrates btn-sm invisible"
        data-toggle="modal"
        data-target={`#${idModalFilters}`}
      />

      <ModalContentAux
        idModal={idModalFilters}
        size="large"
        showFooter={false}
        classModalDialog="modal-dialog-scrollable"
        title={
          <>
            <i className="fas fa-filter" /> Filtros
          </>
        }
        content={
          <ModalFilters
            user={user}
            setPagePagination={setPagePagination}
            pagePagination={pagePagination}
            setIsFiltered={setIsFiltered}
            isFiltered={isFiltered}
          />
        }
      />

      <span
        id={`spanModal${modal.modalId}`}
        className="invisible"
        data-toggle="modal"
        data-target={`#${modal.modalId}`}
        data-backdrop="static"
        data-keyboard="false"
        data-dismiss="modal"
        ref={refModalStatus}
      />

      <ModalContentAux
        idModal={modal.modalId}
        title={modal.title}
        size={modal.size}
        onClose={() => {
          setModal({
            title: '',
            content: null,
            modalId: null,
            size: 'extra',
          })
        }}
        content={modal.content}
        showFooter={false}
      />
    </>
  )
}

export default WaterTruckRequest
